import { useContext } from 'react'
import { useDispatch } from 'react-redux'
import useQuery from '@cbgms/base/http/use-query'
import { IVehicleAttribute } from '@cbgms/api'
import { ShopCountry } from '@cbgms/base/shop-id'
import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import { loadVehicleDetails } from 'app/vehicles/state/actions'

export const useGetMDMDetails = (country: ShopCountry, enabled: boolean, attributes: IVehicleAttribute[]) => {
  const dispatch = useDispatch()
  const { locale } = useContext(LocaleContext)

  return useQuery(
    ['MDMDETAILS', locale, country, JSON.stringify(attributes)],
    async () => {
      const { Data } = await dispatch(loadVehicleDetails(locale, country, attributes))
      return Data
    },
    {
      enabled,
      staleTime: 2 * 60 * 1000
    }
  )
}
